<template>
  <div>
    <OlympicsComp v-bind:mobile="mobile"/>
    <RedirectActivitiesComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import RedirectActivitiesComp from '@/components/desktop/Activities/RedirectActivitiesComp'
import OlympicsComp from "@/components/desktop/Activities/OlympicsComp";
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'Olympics',
    props: ['mobile'],
    components: {
      OlympicsComp,
      RedirectActivitiesComp,
      FollowUs
    },
  }
</script>
